import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-homefour-funfacts",
    templateUrl: "./homefour-funfacts.component.html",
    styleUrls: ["./homefour-funfacts.component.scss"],
})
export class HomefourFunfactsComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}

    singleFunfactsItem: Funfacts[] = [
        {
            icon: "assets/img/funfacts/kepler.png",
            title: "10 Years",
            subTitle: "On the market",
            link: "https://portal.kepler.xom.cloud/dashboard",
            imageClass: "",
        },
        {
            icon: "assets/img/funfacts/mdp-logo.png",
            title: "45+",
            subTitle: "Team members",
            link: "https://ishareteam6.na.xom.com/sites/NextField/MDP/_layouts/15/start.aspx#/#InplviewHashd8f5c0b2-9132-4540-848b-93d15f26cd5f=",
            imageClass: "",
        },
        {
            icon: "assets/img/funfacts/UDA.png",
            title: "100%",
            subTitle: "Satisfaction rate",
            link: "https://ishareteam4.na.xom.com/sites/Digital/src1/index.html",
            imageClass: "udaImage",
        },
        {
            icon: "assets/img/funfacts/OSDU.png",
            title: "90%",
            subTitle: "Senior scientist",
            link: "https://wiki.na.xom.com/index.php/Open_Subsurface_Data_Universe_(OSDU)",
            imageClass: "",
        },
    ];
}
class Funfacts {
    icon: string;
    title: string;
    subTitle: string;
    link: string;
    imageClass: string;
}
